<template>
  <div>
    <div class="">
      <div class="page-operate-block">
        <span class="tit">参数列表</span>
        <div>
          <el-button v-permission="'add'" class="operate-btn" @click="handleAdd">新增</el-button>
          <el-button v-permission="'delete'" class="operate-btn" :disabled="selection.length == 0" @click="handleDelete">批量删除</el-button>
        </div>
      </div>
      <div class="table-list-block">
        <el-table
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          :data="tableData"
          class="table table-stripped"
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50" />
          <el-table-column min-width="200px" label="展示名称" prop="displayName" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column min-width="200px" label="参数" prop="name" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column min-width="200px" label="值" :show-overflow-tooltip="true">
            <template #default="scope">
              <span v-if="scope.row.style === 1">
                <el-input
                  v-show="scope.row.isEdit"
                  v-model="scope.row.value"
                  autofocus
                  class="zbl-editTable"
                ></el-input>
                <span v-show="!scope.row.isEdit" class="zbl-paramValSpan">{{ scope.row.value }}</span>
              </span>
              <span v-if="scope.row.style === 2 || scope.row.style === 5">
                <el-input
                  v-show="scope.row.isEdit"
                  v-model="scope.row.value"
                  autofocus
                  class="zbl-editTable"
                  type="number"
                ></el-input>
                <span v-show="!scope.row.isEdit" class="zbl-paramValSpan">{{ scope.row.value }}</span>
              </span>
              <span v-if="scope.row.style === 3">
                <el-radio v-model="scope.row.value" label="true" :disabled="!scope.row.isEdit">true</el-radio>
                <el-radio v-model="scope.row.value" label="false" :disabled="!scope.row.isEdit">false</el-radio>
              </span>
              <span v-if="scope.row.style === 4 && scope.row.name != 'officialSealImg'">
                <span class="zbl-paramValSpan" v-text="scope.row.value"></span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            v-permission="'update'"
            min-width="80px"
            label="操作"
            align="center"
          >
            <template #default="scope">
              <template v-if="scope.row.style === 4">
                <el-upload
                  v-if="!areUOk"
                  class="upload-demo"
                  ref="upload"
                  :action="uploadUrl"
                  :before-upload="beforeAvatarUpload"
                  :on-error="handleUploadFail"
                  :on-success="handleUploadSuccess"
                  :show-file-list="false"
                >
                  <el-button
                    type="primary"
                    class="btn-xs btn-white uploadBtnSize"
                    @click="uploadImg(scope.row, $event)"
                  >
                    <i class="fa fa-file-image-o"></i>
                  </el-button>
                </el-upload>
                <el-button
                  v-else
                  type="primary"
                  class="btn-xs btn-white uploadBtnSize is-plain"
                  @click="uploadImg(scope.row, $event)"
                >
                  <i class="fa fa-check"></i>
                </el-button>
              </template>
              <a @click="submitEdit(scope.row, $event)" v-else>
                <span v-if="!scope.row.isEdit" class="operate">编辑</span>
                <span v-else class="operate">完成</span>
              </a>
            </template>
          </el-table-column>
          <el-table-column
            min-width="280px"
            label="参数说明"
            prop="description"
            align="left"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
        </el-table>
        <RPagination :pagination="pagination" @current-change="handlePageChange"></RPagination>
      </div>
    </div>

    <RModal
      title="新增"
      top="15vh"
      :show="editModal"
      :closeOnClick="false"
      width="640px"
      @change="editModal = false"
      @close="editModal = false"
    >
      <template #content>
        <EditView @success="handleSuccess" @close="editModal = false" />
      </template>
    </RModal>
  </div>
</template>
<script>
import mixin from "@/components/common/tableMixin";
import RPagination from "@/components/common/RPagination";
import { mapActions } from "vuex";

import RModal from "@/components/common/RModal"
import EditView from './editView.vue'

export default {
  name: "systemParamsComponent",
  components: { RPagination, RModal, EditView },
  mixins: [mixin],
  data() {
    return {
      editModal: false,
      uploadUrl: location.origin + '/sass/api/web/fileStorage/upload',

      areUOk: false,
      pageSize: 50,
      page: 1,
      loading: false,
      tableData: [],
      oldValue: {},
      pagination: { pageSize: 20, pageIndex: 1, total: 0 },
      selection: [],
    };
  },
  props: {
    reqType: {
      type: String,
      default: "1",
    },
  },
  created() {
    if (this.reqType !== "999") {
      this.fetchDataIfNeeded(this.getReqParams());
    }
  },
  methods: {
    ...mapActions(["importUpload"]),
    // 获取请求参数
    getReqParams() {
      return {
        type: this.reqType,
        pageSize: this.pagination.pageSize,
        pageNumber: this.pagination.pageIndex,
      }
    },
    // 处理成功
    handleSuccess() {
      this.fetchDataIfNeeded(this.getReqParams())
      this.editModal = false
    },
    // 处理新增
    handleAdd() {
      this.editModal = true
    },
    // 处理删除
    handleDelete() {
      this.$confirm(
        '确定删除当前选中的（' + this.selection.length + '条记录）信息吗？',
        { type: 'warning' }
      ).then(() => {
        let url = 'SYSTEM.PARAM.POST_DELETE'
        let params = this.selection.map(item => item.id)

        this.fetchData({ url, method: "post", params, headers: { 'Content-Type': 'application/json' }, flag: true })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("删除成功！");
              this.fetchDataIfNeeded(this.this.getReqParams())
            } else {
              this.$message.error(res.msg || '删除失败！')
            }
          })
          .catch((err) => {
            this.$message.success(err);
          });
      })
    },
    // 处理编辑
    submitEdit(row, evt) {
      row.isEdit = !row.isEdit;
      let name = row.name;
      let value = row.value;
      if (row.isEdit) {
        $(evt.currentTarget).addClass("is-plain");
        this.oldValue[name] = value;
      } else {
        $(evt.currentTarget).removeClass("is-plain");
        if (this.oldValue[name] === value) return; // 值未做修改不发送请求
        let params = { id: row.id, value };

        let url = "SYSTEM.PARAM.POST_SAVE_OR_UPDATE";
        this.fetchData({ url, method: "post", params, headers: { 'Content-Type': 'application/json' }, flag: true })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("编辑成功！");
            } else {
              this.$message.error(res.msg || '编辑失败！')
            }
          })
          .catch((err) => {
            this.$message.success(err);
          });
      }
    },
    _fetch(params) {
      this._requestData();
      let url = "SYSTEM.PARAM.GET_LIST";
      this.fetchData({
        url,
        method: "get",
        params,
      })
        .then((res) => {
          this._receiveData();
          if (!res || !res.data) {
            this.tableData = []
            this.pagination.total = 0;
            return this.$message.error('暂无数据')
          }
          this.pagination.total = res.rowCount;
          this.tableData = this._getter(res.data) || [];
        })
        .catch((err) => {
          this._receiveData();
          this.$message.error(err);
        });
    },
    _getter(items) {
      return items.map((data, index) => {
        data["isEdit"] = false;
        Object.keys(data).forEach(function (key) {
          if (data[key] === null) {
            data[key] = "";
          }
        });
        return data;
      });
    },
    // 处理上传成功
    handleUploadSuccess(res, file) {
      let row = this.rowSelected;
      row.isEdit = true;
      if (res.code == 200) {
        this.rowSelected.value = res?.data.url || this.rowSelected.value
      }
    },
    // 处理上传失败
    handleUploadFail(e) {
      this.$message.error('上传失败！请重试')
    },
    // 上传约束
    beforeAvatarUpload(file) {
      let tailType = file.name.slice(file.name.lastIndexOf(".") + 1);
      let isType = ["jpeg", "jpg", "png"].indexOf(tailType.toLowerCase()) > -1;
      if (!isType) {
        this.$message.error("只能上传jpeg/jpg/png文件");
        return false;
      }

      const isLtM = file.size / 1024 / 1024 <= 2;
      if (!isLtM) {
        this.$message.error("上传附件大小不能超过 2MB!");
        return false;
      }
      this.areUOk = true;
      
      return true
    },
    uploadImg(row, evt) {
      evt.currentTarget.nextSibling.type = "text"; //阻止再次弹框选择文件
      this.curEvt = evt
      if (!row.isEdit) {
        this.rowSelected = row;
        evt.currentTarget.nextSibling.type = "file";
        return;
      }

      if (this.areUOk) {
        this.areUOk = false
        this.submitEdit(row, evt)
      }
    },
    // 处理表格选中
    handleSelectionChange(list) {
      this.selection = list
    },
    // 分页跳转
    handlePageChange(page) {
      this.pagination.pageIndex = page;
      this._fetch({
        type: 1,
        pageSize: this.pagination.pageSize,
        pageNumber: this.pagination.pageIndex,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.operate {
  cursor: pointer;
  color: @font-darkblue-color-theme;
}
.systemParams .zbl-editTable :deep(input) {
  border: 1px solid #dcdfe6 !important;
}
.uploadBtnSize {
  width: 25px;
  height: 25px;
}
</style>
